import { Menu } from '@/components/organisms/Menu/Menu'
import React from 'react'
import Image from 'next/image'
import video from '@/pages/help_center/watch_videos/video/video.module.scss'

import { NavLink } from '@/components/atoms/NavLink/NavLink'
import { Footer } from '@/components/organisms/Footer/Footer'
import { VideoList } from '@/components/organisms/VideoList/VideoList'
import { videolist } from '@/data/dummy/videolist'

export default function index () {
  function chunk (arr, size) {
    return arr.reduce((result, item, index) => {
      const chunkIndex = Math.floor(index / size)
      if (!result[chunkIndex]) {
        result[chunkIndex] = []
      }
      result[chunkIndex].push(item)
      return result
    }, [])
  };
  const videolistGrups = chunk(videolist, 1)
  return (
    <>
      <Menu />

      <div className={video.wrapper}>
        <div className={video.column_1}>
          <div className={video.posvideo}>
            <iframe
              width='760'
              height='647'
              src='https://www.youtube.com/embed/XXnOxB_cCdE?autoplay=1'
              title='YouTube video player'
              className={video.tamañovideo}
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
            />
          </div>
          <div className={video.padtitle}>
            <h2 className={video.video_title}>BASYS Sistema administrativo de basculas camionras, contrl de inventarios materiales reciclados</h2>
            <p className={video.fecha}>28/10/2012</p>
            <p className={video.comentarios}>28 comentarios</p>
            <div className={video.comments}>
              <div className={video.new_comment}>
                <Image
                  src='/img/help_center/imgvideo/oval.png'
                  alt='Foto de perfil'
                  width={50}
                  height={50}
                />
                <textarea placeholder='Escribe un comentario...' />
              </div>
              <div className={video.old_comment}>
                <Image
                  src='/img/help_center/imgvideo/oval1.png'
                  className={video.imagencoment}
                  alt='Foto de perfil'
                  width={50}
                  height={50}
                />
                <div className={video.comment_info}>
                  <h3 className={video.titcomment}>Devin Green <span className={video.fechcoment}>05/21/2011</span></h3>
                  <span className={video.textcoment}>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span>
                  <span className={video.textcoment2}>Lorem ipsum dolor sit amet, consectetur adipiscing.</span>
                </div>
              </div>
              <div className={video.old_comment}>
                <Image
                  src='/img/help_center/imgvideo/oval2.png'
                  className={video.imagencoment}
                  alt='Foto de perfil'
                  width={50}
                  height={50}
                />
                <div className={video.comment_info}>
                  <h3 className={video.titcomment}>Devin Green <span className={video.fechcoment}>05/21/2011</span></h3>
                  <span className={video.textcoment}>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span>
                  <span className={video.textcoment2}>Lorem ipsum dolor sit amet, consectetur adipiscing.</span>
                </div>
              </div>
              <div className={video.old_comment}>
                <Image
                  src='/img/help_center/imgvideo/oval3.png'
                  className={video.imagencoment}
                  alt='Foto de perfil'
                  width={50}
                  height={50}
                />
                <div className={video.comment_info}>
                  <h3 className={video.titcomment}>Devin Green <span className={video.fechcoment}>05/21/2011</span></h3>
                  <span className={video.textcoment}>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span>
                  <span className={video.textcoment2}>Lorem ipsum dolor sit amet, consectetur adipiscing.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={video.column_2}>
          {
      videolistGrups.map((group, index) => (
        <div key={index} className={video.with_image}>

          {group.map((videolist, index) => (
            <VideoList key={index} {...videolist} />
          ))}
        </div>
      ))
          }
          <div className={video.container2}>
            <NavLink href='/help_center/watch_videos' type='submit' name='Volver' className={video.button3} />
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}
